<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container
        v-if="!loading && items.length"
        class="px-md-4 pt-10 pt-md-13 pt-lg-16"
      >
        <div
          class="primary--text text-h6 text-md-h5 text-center font-weight-bold"
        >
          Materiais recolhidos e comercializados
        </div>

        <v-row class="mx-md-n4 mt-6 mt-md-10">
          <template v-for="(item, keyItems) in items">
            <v-col
              :key="keyItems"
              class="px-md-4"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <MaterialCard v-bind="item" />
            </v-col>
          </template>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import MaterialCard from "../cards/MaterialCard.vue";

const _config = {
  mod: "materials",
};

export default {
  props: {
    itemsPerPage: {
      type: Number,
      default: 1000,
    },
  },
  data: () => ({
    loading: true,
    items: [],
  }),
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        itemsPerPage: this.itemsPerPage,
      };

      this.$rest(_config.mod)
        .get({ params })
        .then((data) => (this.items = data))
        .then(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  components: {
    LoadingWidget,
    MaterialCard,
  },
};
</script>
